import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'batch_number', label: 'Batch Number' },
  { key: 'batch_date', label: 'Batch Date' },
  { key: 'transaction_count', label: 'Transactions', align: 'right' },
  { key: 'total_value', label: 'Total Value', align: 'right', type: 'money' },
  { key: 'status', label: 'Status' },
  { key: 'generated_at', label: 'Generated At' },
];

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'generated', label: 'Generated' },
  { value: 'failed', label: 'Failed' },
  { value: 'exported', label: 'Exported' },
  { value: 'completed', label: 'Completed' },
];

export function InterfaceLogReport() {
  return (
    <ReportView
      title="GL Daily Interface Log"
      description="Every automated GL batch generated, with transaction count, total value, and posting status."
      endpoint="/reports/gl/interface-log"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
      defaultSort="batch_date"
    />
  );
}
